var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_253_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_253_9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_253_9",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_253_9",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADUklEQVR4nO2du2sUURSHR9HWRxf3nN3gozBisvfsQtAqTZS456xWsdZWuxS+GkGw1MpSDT7BNApWYiMqImqjEvwvBDubbGRiSELUZJydmXs0vw9um82cb85jZmf2JgkAAAAAAAAAAAAAAADEIhxvHAhKF0VpWoxnNtRSml449s7AUBKb9vie7aL0UIx7Yjy/wVdPjO6PTuzbFk+G0WcHgZj3tILyxyhSFjMjegDE4QrG9yrvGShTvJaUXqU9JShdin0WivMVjC5UJmRxmop+0OJ4BaNb1Qn5OfJFP2jxvWYgxKJLgBCJH3gIkfjBhhCJH2AIkfhBhRCpNGj0NRh9EqUXovRYlJ6I8fNg9DIYfRCl2WD0DRliJUpQetcyPjuifDBJkk1ZRtOmMqFkWbEigtL7oLXxPNcGzRODOyDECpVxo91ub817oQYhVqyMvCIgxAouU8Zvx8aSLRDiZDWVR/uVgZJlhZWqV0XIgBArRkirWzsJIX5Wb1gbOyHEy1Ka/VsZ7Yn63mB0LChNrl7Nbv1Ujv8D34fIcv+4nVWEdAYGRfl1CScGhMhSMOhKFhnpSFzio0wQIkvBqE9lERKUOiWWTgiR5WCczlSujK9CSAVNPShNZhRyB0IcCQnKjyDEkRAp93Em9BCBkPLPdkGGRE/1+T+XIn6T5SWaVpcOZStZ9amML+U8Q8my/L2haJpWPwoh5kdIMD4DIeZIiPJ1CDFXQp5CiLkS8gVCzImQy8lmMfoOIeZDyEi3sRtX6tbfLZEiCd36EQgxR0Lyjbwb415WULr2u++8V6/hCeJsx1E7vN7fWngqHkIY97L+hQyR7JmE2++xJQiExA+8QAhKlmQ/Mf7/KUuQIRAi+U8MZIhgyopfngRTFnqIoGQxMgRTFvdbOtHUBU09fgMXNHU0dUHJYmQImjqjqQt6CG4uSnnDBcZewdgbf8QVjL0YewUli5Eha5H+dEXssiTeS5bSzaQqvG9XERwIqXa7is7AkOcNXUJsIcpzbdu1v3wTKw9G6UHswItTIUH5blI16cZXC78K7UCAOBISbVOwlPSD063ivJWvEEOI8lyaGdFk/NJTlM572ViyVfR76utsLCnK5yrvGQAAAAAAAAAAAAAAAJCs4AeC90QzamNc9QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b6590866790768a2a1c832cb091aa302.svg";
export { ForwardRef as ReactComponent };